import {
  GatsbyImage,
  getImage,
  IGatsbyImageData,
  withArtDirection,
} from "gatsby-plugin-image"
import React from "react"
import { ImageData } from "types/interfaces"

interface Props {
  data: ImageData
}

const ImageWithSrcSet: React.FC<Props> = ({ data }) => {
  const images: IGatsbyImageData = withArtDirection(
    getImage(data.largeImage)!,
    [
      {
        media: "(max-width: 1023px)",
        image: getImage(data.smallImage)!,
      },
    ]
  )

  return <GatsbyImage image={images} alt={"movezee"} />
}

export default ImageWithSrcSet
